import { createContext, useContext } from "react";
import type { DiscoveryLaunchOptions } from "@/discovery/presentation";

export type DiscoveryHostApi = {
  openDiscovery: (options: DiscoveryLaunchOptions) => void;
  closeDiscovery: () => void;
  isDiscoveryOpen: boolean;
  onboardingRequest: { returnFocus: HTMLElement | null } | null;
};

export const DiscoveryHostContext = createContext<DiscoveryHostApi | null>(null);

export function useDiscoveryHost(): DiscoveryHostApi {
  const value = useContext(DiscoveryHostContext);
  if (!value) throw new Error("useDiscoveryHost must be used within DiscoveryHostProvider.");
  return value;
}
